// One published policy set for the website, application and companion links.
export const LEGAL_LINKS = Object.freeze({
  privacy: "https://selenne.io/privacy.html",
  terms: "https://selenne.io/terms.html",
});
